import { Injectable } from '@angular/core';
import { Statique } from '../utils/statique';
import { Http, Response } from '@angular/http';
import { AuthHttp } from 'angular2-jwt';
import { SearchCriteria } from '../utils/searchCriteria';
import { EbEtablissement } from '../classes/etablissement';
import { EbChat } from '../classes/chat';

@Injectable()
export class ChatService {

	constructor(private http: Http, private authHttp:AuthHttp) { }

	getListChatByDemande(demande) {
		return this.http.get(Statique.controllerStatiqueListe + "/listChat?demande=" + demande).
			map((res: Response) => res.json());
	}

	getListChat(dataSource : string) {
		return this.http.get(dataSource).
			map((res: Response) => res.json());
	}

	addChat(dataInsertion: string, chat: EbChat) {
		return this.authHttp.post(dataInsertion, chat).
			map((res: Response) => res.json());
	}
}



// WEBPACK FOOTER //
// ./src/app/services/chat.service.ts